<template>
    <el-tag v-if="orderState === ORDER_STATE.WAITING"
            type="info"
            effect="dark">대기중
    </el-tag>
    <el-tag v-else-if="orderState === ORDER_STATE.CANCEL"
            type="danger"
            effect="dark">취소됨
    </el-tag>
    <el-tag v-else-if="orderState === ORDER_STATE.REJECT"
            type="danger"
            effect="dark">거절됨
    </el-tag>
    <el-tag v-else-if="orderState === ORDER_STATE.RESOLVE"
            type="success"
            effect="dark">제작중
    </el-tag>
    <el-tag v-else-if="orderState === ORDER_STATE.SHIPPING"
            type="success"
            effect="dark">배송중
    </el-tag>
    <el-tag v-else-if="orderState === ORDER_STATE.COMPLETE"
            type="primary"
            effect="dark">배송완료
    </el-tag>
</template>

<script>
    import {ORDER_STATE} from '@/const';

    export default {
        name: 'OrderStateTag',
        props: {
            orderState: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                ORDER_STATE,
            };
        },
    };
</script>

<style lang="scss" scoped>

</style>